import domains from './domains'

export default {
  namespaced: true,
  modules: {
    domains
  }
}
